<span class="p-float-label mt-4">
	<p-dropdown
		#storedCreditCardSelect
		[options]="creditOptions"
		optionLabel="displayName"
		name="storedCreditCardSelect"
		[(ngModel)]="selectedCardValue"
		[style]="{ width: '100%' }"
		appendTo="body"
		[autoDisplayFirst]="false"
		(onChange)="selectCreditCard()"
	>
		<ng-template pTemplate="selectedItem">
			<div class="d-flex w-100">
				<fa-icon *ngIf="selectedCardValue.type === 'CC'" [icon]="['fad', 'credit-card-front']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="selectedCardValue.type === 'VS'" [icon]="['fab', 'cc-visa']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="selectedCardValue.type === 'MC'" [icon]="['fab', 'cc-mastercard']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="selectedCardValue.type === 'AX'" [icon]="['fab', 'cc-amex']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="selectedCardValue.type === 'NS'" [icon]="['fab', 'cc-discover']" size="xl" class="my-auto"></fa-icon>
				<div class="ms-2 my-auto display-14">{{ selectedCardValue.displayName }}</div>
			</div>
		</ng-template>
		<ng-template let-rec pTemplate="item">
			<div class="d-flex w-100">
				<fa-icon *ngIf="rec.type === 'CC'" [icon]="['fad', 'credit-card-front']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="rec.type === 'VS'" [icon]="['fab', 'cc-visa']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="rec.type === 'MC'" [icon]="['fab', 'cc-mastercard']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="rec.type === 'AX'" [icon]="['fab', 'cc-amex']" size="xl" class="my-auto"></fa-icon>
				<fa-icon *ngIf="rec.type === 'NS'" [icon]="['fab', 'cc-discover']" size="xl" class="my-auto"></fa-icon>
				<div class="ms-2 my-auto display-14">{{ rec.displayName }}</div>
			</div>
		</ng-template>
	</p-dropdown>
	<label for="storedCreditCardSelect">Select previously used credit card</label>
</span>
